import React from 'react';
// import { ResponsiveTable } from "responsive-table-react";
import { ResponsiveTable } from "../tablenode/responsive-table-react";
import '../style/css/tableforedit.css'

const TableForEdit = () => {
    const columns = [
        {
            "id": "שם מלא",
            "text": "שם מלא"
        },
        {
            "id": "כמות אנשים",
            "text": "כמות אנשים"
        },
        {
            "id": "איזור",
            "text": "איזור"
        },
        {
            "id": "שולחן",
            "text": "שולחן"
        },
        {
            "id": "שעה",
            "text": "שעה"
        },
        {
            "id": "מספר פלאפון",
            "text": "מספר פלאפון"
        }
    ]

    const data = [
        {
            "שם מלא": "דוד המלך",
            "כמות אנשים": "4P",
            "איזור": "פאב - בר",
            "שולחן": "301",
            "שעה": "18:30",
            "מספר פלאפון": "050-9999999",
        },
        {
            "שם מלא": "Gabriel",
            "כמות אנשים": "33P",
            "איזור": "פאב -כניסה",
            "שולחן": "203",
            "שעה": "18:30",
            "מספר פלאפון": "050-9999999",
        },
        {
            "שם מלא": "Gustav",
            "כמות אנשים": "14P",
            "איזור": "פאב - מלצרים",
            "שולחן": "15",
            "שעה": "18:30",
            "מספר פלאפון": "050-9999999",
        }
    ]
    const filterColumnNames =[]
    const btns = [
        {name: 'DELETE', action: 1},
        {name: 'EDIT', action: 2},
    ]
    return (
        <ResponsiveTable className={'table-arrow'}btns={btns} columns={columns} data={data} filterColumnNames={filterColumnNames}/>
    )
};

export default TableForEdit;